export enum RouterParam {
    Popup = "popup",
    NotificationId = "notification-id",
    PageId = "page_id",
    Id = "id",
    Group = "group",
    Page = "page",
    Credits = "credits",
    Reference = "reference"
};